import show from './show';
import update from './update';

export default {
  show,
  update,
};



// WEBPACK FOOTER //
// ./src/app/services/address/index.js